import { render, staticRenderFns } from "./ImportDemand.vue?vue&type=template&id=fb9139f6&scoped=true"
import script from "./ImportDemand.vue?vue&type=script&lang=js"
export * from "./ImportDemand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9139f6",
  null
  
)

export default component.exports